"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var ThreadListLayout = function ThreadListLayout(_ref) {
  var isEmpty = _ref.isEmpty,
      fallback = _ref.fallback,
      header = _ref.header,
      actions = _ref.actions,
      children = _ref.children;

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      shadow = _useState2[0],
      setShadow = _useState2[1]; // Scroll top from list


  var _useState3 = (0, _react.useState)(0),
      _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
      scrollTop = _useState4[0],
      setScrollTop = _useState4[1];

  var renderProps = {
    setShadow: setShadow,
    setScrollTop: setScrollTop,
    scrollTop: scrollTop
  };
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "h-full flex flex-col"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('py-5 z-10', {
      'shadow-hover dark:shadow-shallow': shadow
    })
  }, typeof header === 'function' ? header(renderProps) : header, !isEmpty && actions), /*#__PURE__*/_react["default"].createElement("div", {
    className: "h-full"
  }, typeof children === 'function' ? children(renderProps) : children, isEmpty && fallback));
};

var _default = ThreadListLayout;
exports["default"] = _default;
//# sourceMappingURL=index.js.map